// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.experience-card {
  display: flex;
  margin: 15px;
}

.experience-card__img {
  max-width: 175px;
  min-width: 175px;
  overflow: hidden;
  object-fit: contain;
}

.experience-card__contents {
  align-self: start;
  margin-left: 25px;
}

.experience-card__contents > p {
  max-width: 750px;
}
`, "",{"version":3,"sources":["webpack://./src/components/elements/experience-card/experience-card.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".experience-card {\n  display: flex;\n  margin: 15px;\n}\n\n.experience-card__img {\n  max-width: 175px;\n  min-width: 175px;\n  overflow: hidden;\n  object-fit: contain;\n}\n\n.experience-card__contents {\n  align-self: start;\n  margin-left: 25px;\n}\n\n.experience-card__contents > p {\n  max-width: 750px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
